import InfoBar from './infobar';
import Gun from '../managers/Gun';
import { bulletType } from "../assets/data/enum";
import Player from './player';
import TweenedText from './text';
export default class Enemy extends Phaser.GameObjects.Image {
    public tag: string;
    public name: string;
    public body: Phaser.Physics.Arcade.Body;
    private _speed: number;
    private _boundaryBottom: number; // bottom boundary
    private _boundaryLeft: number;
    private _boundaryRight: number;
    // private _boundaryTop: number;// top boundary
    private MAX_HEALTH = 100;
    public health: number = this.MAX_HEALTH;
    private _healthBar: InfoBar;
    private _gun: Gun = null;
    private _target: Player;
    private _stopCallback: Function;
    private _move: Function;
    private _checkBoundary: Function;
    private _boundaryHitCallback: Function;
    private _lane: any;
    public bountyValue: number;
    private _bountyText: TweenedText;
    public explosion: Phaser.GameObjects.Sprite;
    private _explosion_audio: Phaser.Sound.BaseSound;
    private _explosionMovementTween: Phaser.Tweens.Tween;
    private _explosionDistance: number;
    private _movementTween: Phaser.Tweens.Tween;
    private _updateCounter: number;
    private _updateCounterMax: number;
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame?: string) {
        super(scene, x, y, key, frame);
        this.tag = frame;
        let name = this.tag.split("_");
        if(parseInt(name[name.length-1])>-1) {
            name.pop();
        }
        this.name = name.join("_");
        // this.tag = key;
        scene.add.existing(this);
        this._boundaryBottom = window.constants.BASE_HEIGHT + this.height;
        // this._speed = speed || Math.floor(Phaser.Math.GetSpeed(window.constants.BASE_HEIGHT / 5, 10));
        this.setOrigin(0.5, 0.5);

        this._checkBoundary = this._checkBottomBoundary;
        this.bountyValue = window.constants.DATA.hitScore[this.name] || 0;
        if (this.name == "tank") {
            this._boundaryLeft = Math.round(window.constants.BASE_WIDTH / 9);
            this._boundaryRight = window.constants.BASE_WIDTH - Math.round(window.constants.BASE_WIDTH / 9);
            this._boundaryBottom = Math.floor(this.displayHeight * 1.3);
            this._boundaryHitCallback = () => {
                if (this.x < this._boundaryLeft) {
                    this.x = this._boundaryLeft + 1;
                    this._speed = Math.abs(this._speed);
                }
                else if (this.x > this._boundaryRight) {
                    this.x = this._boundaryRight - 1;
                    this._speed = -1 * Math.abs(this._speed);
                }
                this._checkBoundary = this._checkHorizontalBoundary;
                // this.body.setVelocity(this._speed, 0);
                this._move = this._moveHorizontal.bind(this);
                // this._speed *= -1;
            }
        }
        else {
            this._boundaryHitCallback = this.stop;
        }
        let fontSize = (window.constants["HD_FLAG"])? 50 : 12;
        this._bountyText = new TweenedText(this.scene, this.x, this.y, "+" + this.bountyValue, -(Math.floor(window.constants.BASE_HEIGHT * 0.05)), null, 0, {fontSize: fontSize, fontFamily: "font_2"}, 500);
        this.explosion = this.scene.add.sprite(0, 0, "assets", 'explosion_0');
        this._explosionDistance = window.constants.BASE_HEIGHT * 0.22;
        this._explosionMovementTween = this.scene.add.tween({
            targets: this.explosion,
            y: "+=30",
            ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: 1000,
            repeat: 0,            // -1: infinity
            yoyo: false
        });
        this.explosion.setVisible(false);
        // let explosionScale = 4;
        // this.explosion.setScale(explosionScale)
        // this._explosion_audio = this.scene.sound.add("explosion", {
        //     loop: false,
        //     volume: (window.constants["VOLUME"] * 1.3)
        // });
        this._initPhysics();

        this._updateCounter = 5;
        this._updateCounterMax = 5;

        this.stop(true);
    }
    
    private _createMovementTween(){
        let duration = Math.floor((window.constants["BASE_HEIGHT"] / (this._speed * 0.016 * 60)) * 1000);
        this._movementTween = this.scene.add.tween({
            targets: this,
            y: {"from": - Math.floor(this.height * 0.5), "to": this._boundaryBottom},
            ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
            duration: duration,
            repeat: 0,            // -1: infinity
            yoyo: false,
            onComplete: this._boundaryHitCallback.bind(this),
            onCompleteScope: this
        })
        this._movementTween.stop();
    }
    
    private _equip() {
        let speed = window.constants["DATA"]["speed"]["bullet_"+this.name];
        let bulletName = "bullet_" + this.name;
        let gunName = "gun_" + this.name;
        let barrel = this.scene.textures.getFrame("assets", gunName);
        let colliderData = JSON.parse(JSON.stringify(window.constants.DATA["colliderOffset"][gunName]))
        colliderData.x = 0;
        colliderData.y = (barrel.height * 0.5) - (colliderData.y);
        switch (this.name) {
            case "buggy":
                {
                    this._gun = new Gun("bg",  "assets", "enemy_bullet", 2, speed, bulletType.buggy, colliderData, this, 1, this.parentContainer, this._target, window.constants.DATA.rateOfFire[bulletName], window.constants.DATA.rateOfRounds[bulletName]);
                }
                break;
            case "battle_truck":
                {
                    this._gun = new Gun("btg", "assets", "enemy_bullet", 2, speed, bulletType.buggy, colliderData, this, -1, this.parentContainer, this._target, window.constants.DATA.rateOfFire[bulletName], window.constants.DATA.rateOfRounds[bulletName]);
                }
                break;
            case "tank":
                {
                    this._gun = new Gun("tg",  "assets", "enemy_bullet", 2, speed, bulletType.buggy, colliderData, this, -1, this.parentContainer, this._target, window.constants.DATA.rateOfFire[bulletName], window.constants.DATA.rateOfRounds[bulletName]);
                }
                break;
        }
    }

    private _initPhysics(): void {
        this.scene.physics.world.enable(this);
        this.body.setAllowGravity(false);
        this.body.setAllowDrag(false);
        this.body.setAllowRotation(false);
        this.body.setImmovable(true);
        this.body.moves = false;
        try{
            let colliderData = window.constants.DATA.colliders[this.name];
            this.body.setSize(colliderData.width, colliderData.height);
            this.body.setOffset(colliderData.x, colliderData.y);
            this.setOrigin(colliderData.pivotX, colliderData.pivotY);
        } catch(e) {
            // console.log(this.name+" does not have collider data");
        }
    }

    private _moveOffScreen() {
        this.x = window.constants.BASE_WIDTH + 100;
        this.y = window.constants.BASE_HEIGHT + 600;
    }

    public setSpeed(speed) {
        this._speed = speed;
    }

    public setProperties(health: number, speed: number, lane: any, target?: Player, callback?: Function) {
        this.setScale(window.constants["OBJECT_SCALE"]);
        this.health = health;
        this.MAX_HEALTH = health;
        this._lane = lane;
        let position = this._lane.position;
        this._speed = speed;
        this.setPosition(position.x, position.y);
        if (target) {
            this._target = target;
            this._equip();
        }
        if (callback) {
            this._stopCallback = callback;
        }
        let timerBar = this.scene.textures.getFrame("assets", "timer_bar_mini");
        let h = timerBar.height, w = timerBar.width;
        this._healthBar = new InfoBar(this.scene, this, this.MAX_HEALTH, w, h, "assets", 'timer_bar_mini', true, this.x, this.y);
        this._healthBar.stop();
        // this._createMovementTween();
    }

    private _moveUp(time, dt){
        this.y -= (Math.floor(this._speed * 3 * dt * 100)*0.01); // dt must be in seconds
    }
    
    private _moveDown(time, dt) {
        this.y += this._speed * dt; // dt must be in seconds
    }
    
    private _moveHorizontal(time, dt) {
        this.x += (Math.floor(this._speed * dt * 100)* 0.01);
    }
    private _checkTopBoundary() {
        if (this.y > 0) {
            return false;
        }
        return true;
    }

    private _checkBottomBoundary() {
        if (this.y > this._boundaryBottom) {
            return true;
        }
        return false;
    }

    private _checkHorizontalBoundary() {
        if (this.x > this._boundaryRight || this.x < this._boundaryLeft) {
            return true;
        }
        return false;
    }

    public hit(hitValue) {
        if (this.y > 0) {
            if (!this._healthBar.active) {
                this._healthBar.start();
            }
            if (this.health) {
                this.health = Math.max(this.health - hitValue, 0);
                this._healthBar.setValue(this.health);
                
            }
            if (this.health <= 0) {
                this._bountyText.start(this.x, Math.floor(this.y - (this.height / 2)));
                this.stop();
                // if fuel_truck -> find near by obstacles -> blast them also
            }
        }
    }

    public getScene() {
        return this.scene;
    }

    public getBullets() {
        if (this._gun) {
            return this._gun.bullets;
        } else {
            return false;
        }
    }

    public reverse() {
        if (this.y > 0 && this.y < this._boundaryBottom) {
            // this.body.setVelocity(0, -Math.abs(this._speed * 2));
            this._move = this._moveUp.bind(this);
            this._checkBoundary = this._checkTopBoundary;
            if (this.name == "tank") {
                this._boundaryHitCallback = this.stop;
            }
        }
    }

    private _startPhysics(x, y) {
        this.scene.physics.world.enable(this);
        this.body.setEnable(true);
        this.body.reset(x, y);
        // this.body.setVelocity(0, this._speed);
    }

    private _stopPhysics() {
        this.body.stop();
        this.body.setEnable(false);
        this.scene.physics.world.disable(this);
    }

    public start(lane: any) {
        // console.log(this.name + " has a depth "+ this.depth);
        switch(this.name) {
            case "tank":
                this._boundaryBottom = Math.floor(this.height * window.constants.DATA.colliderOffset.tank.height * 1.3 * window.constants["OBJECT_SCALE"]);
                this._speed = Math.abs(this._speed);
                break;
            case "hatchback":
                this.setTexture("assets", this.name + "_" + (Math.ceil(Math.random() * 2)));
                break;
        }
        
        let x = lane.position.x, y = lane.position.y - (this.height / 2);
        this.setActive(true);
        this.setVisible(true);
        this._startPhysics(x, y);
        // this._movementTween.restart();
        this._checkBoundary = this._checkBottomBoundary;
        this._move = this._moveDown.bind(this);
        let type;
        switch (this.name) {
            case "buggy":
                type = bulletType.buggy
                if (this._gun) {
                    this._gun.showBarrel();
                    this._gun.shoot(type, 0.5);
                }
                break;
            case "battle_truck":
                type = bulletType.battle_truck
                if (this._gun) {
                    this._gun.showBarrel();
                    this._gun.shoot(type, 2);
                }
                break;
            case "tank":
                type = bulletType.tank
                if (this._gun) {
                    this._gun.showBarrel();
                    this._gun.shoot(type, 2);
                }
                break;
        }
        this.health = this.MAX_HEALTH;

    }

    public stop(initFlag?: boolean, killed?: boolean) {
        this.setActive(false);
        this.setVisible(false);
        this._stopPhysics();
        // if(this._movementTween) {
        //     this._movementTween.stop(0);
        // }
        if (this._gun) {
            this._gun.stop();
        }
        if (!initFlag) {
            if (this.health <= 0 || killed) {
                this.explosion.setPosition(this.x, this.y);
                this.explosion.play("explosion_anim");
                this.scene.tweens.remove(this._explosionMovementTween);
                this._explosionMovementTween = this.scene.add.tween({
                    targets: this.explosion,
                    y: "+="+this._explosionDistance,
                    ease: 'Linear',       // 'Cubic', 'Elastic', 'Bounce', 'Back'
                    duration: 250,
                    repeat: 0,            // -1: infinity
                    yoyo: false,
                })
                // this._explosionMovementTween.updateTo("y", this.y+30);
                // this._explosionMovementTween.restart();
                // this._explosion_audio.play();
            }
            if (this._stopCallback) {
                this._stopCallback(this.name, this._lane, this.x, this.y, this.health <= 0 || killed);
            }
        }
        if (this._healthBar) {
            this._healthBar.stop();
        }
        this._moveOffScreen();
    }

    update(time, dt) {
        if (this.active) {
            // console.log(dt);
            // let delta = dt * 0.001;
            let delta = Math.floor(dt * 10) * 0.0001;
            // console.log(delta);
            this._move(time, delta);
            if(this._healthBar) {
                this._healthBar.update(time, dt);
            }
            if (this._gun) {
                this._gun.update(time, delta);
            }

            if (this._checkBoundary()) {
                this._boundaryHitCallback();
            }

            if (window.constants["GAME_OVER"]) {
                if(this.y < window.constants["BASE_HEIGHT"] * 0.8) {
                    this.reverse();
                }
                if (this._gun) {
                    this._gun.stop();
                }
            } else if (window.constants["FUEL_TRUCK_BLAST"]) {
                if (this.y > window.constants["BLAST_RADIUS_MIN"] && this.y < window.constants["BLAST_RADIUS_MAX"]) {
                    if(this.name != "buggy" && this.name != "battle_truck" && this.name != "tank") {
                        this.stop(null, true);
                    }
                }
            }
            
        }
    }

}